import { useState } from 'react'
import { APP_NAME } from '../constants/config'
import { useTheme } from '../hooks'
import logoSrc from '../assets/images/RADTAR_SKILLASSESS_LOGO.png'

const LOGO_URL = logoSrc

export default function Logo({ size = 'nav' }) {
  const [failed, setFailed] = useState(false)
  const { theme }           = useTheme()

  const blendMode = theme === 'light' ? 'multiply' : 'screen'

  if (size === 'nav') {
    return failed ? (
      <div className="w-9 h-9 rounded-xl flex items-center justify-center text-lg"
           style={{ background: 'var(--badge-bg)', border: '1px solid var(--badge-border)' }}>
        📊
      </div>
    ) : (
      <img
        src={LOGO_URL}
        alt={APP_NAME}
        className="h-10 w-auto object-contain rounded-xl"
        style={{ mixBlendMode: blendMode }}
        onError={() => setFailed(true)}
      />
    )
  }

  // auth pages — larger
  return failed ? (
    <div className="w-16 h-16 rounded-2xl flex items-center justify-center text-3xl mx-auto mb-3"
         style={{ background: 'var(--badge-bg)', border: '1px solid var(--badge-border)' }}>
      📊
    </div>
  ) : (
    <img
      src={LOGO_URL}
      alt={APP_NAME}
      className="h-20 w-auto object-contain rounded-2xl mx-auto mb-3"
      style={{ mixBlendMode: blendMode }}
      onError={() => setFailed(true)}
    />
  )
}
